var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',[_vm._v("Unsplash by Color")]),_c('ColorViz',{attrs:{"msg":"Photos uploaded in May 2019 organized by colors"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }